export default function($) {
  var radio_services = $('.js-radio-services');

  radio_services.on('change', function (e) {

    var radio_id = this.id,
        radio_label = $(this).siblings('.js-radio-label').text();

    $('.js-services-regions').addClass('hidden');

    $('.js-services-regions').each( function() {
      var el = $(this);
      if(el.attr('data-region') === radio_id) {
        el.removeClass('hidden');
      }
    });

    $('.js-radio-service-title').text(radio_label);
  });
}
